module.exports = __webpack_public_path__ + "img/border_Cube.6fbbbef8.svg";